import React from 'react';
import { TrendingUpIcon, ShieldCheckIcon, WrenchIcon, AwardIcon } from 'lucide-react';
import { Card } from '../ui/Card';
import { useTranslation } from '../../lib/i18n';
export function WhyDTechUnified() {
  const {
    lang
  } = useTranslation();
  const en = lang === 'en';
  const ru = lang === 'ru';
  const reasons = en ? [{
    icon: TrendingUpIcon,
    title: 'Proven ROI',
    description: 'Reduce labor costs and improve productivity. Our equipment pays for itself through increased efficiency and reduced workplace injuries.'
  }, {
    icon: ShieldCheckIcon,
    title: 'Safety focus',
    description: 'Minimize manual handling risks. Designed with safety features that protect your team and reduce liability.'
  }, {
    icon: WrenchIcon,
    title: 'Easy maintenance',
    description: 'Simple, straightforward maintenance procedures. Minimal downtime means maximum productivity for your operation.'
  }, {
    icon: AwardIcon,
    title: 'Quality guarantee',
    description: 'Comprehensive warranty and quality assurance. We stand behind every unit with expert technical support.'
  }] : ru ? [{
    icon: TrendingUpIcon,
    title: 'Доказанный ROI',
    description: 'Снижение затрат на рабочую силу и повышение производительности. Наше оборудование окупается за счет повышения эффективности и снижения травматизма на рабочем месте.'
  }, {
    icon: ShieldCheckIcon,
    title: 'Фокус на безопасность',
    description: 'Минимизация рисков ручного перемещения. Разработано с функциями безопасности, которые защищают вашу команду и снижают ответственность.'
  }, {
    icon: WrenchIcon,
    title: 'Простое обслуживание',
    description: 'Простые, понятные процедуры обслуживания. Минимальное время простоя означает максимальную производительность для вашей работы.'
  }, {
    icon: AwardIcon,
    title: 'Гарантия качества',
    description: 'Комплексная гарантия и обеспечение качества. Мы стоим за каждой единицей с экспертной технической поддержкой.'
  }] : [{
    icon: TrendingUpIcon,
    title: 'Dokazani povraćaj investicije',
    description: 'Smanjite troškove rada i poboljšajte produktivnost. Naša oprema se isplaćuje kroz povećanu efikasnost i smanjene povrede na radnom mestu.'
  }, {
    icon: ShieldCheckIcon,
    title: 'Fokus na bezbednost',
    description: 'Minimizirajte rizike od ručnog prenošenja. Dizajnirano sa sigurnosnim funkcijama koje štite vaš tim i smanjuju odgovornost.'
  }, {
    icon: WrenchIcon,
    title: 'Lako održavanje',
    description: 'Jednostavne, direktne procedure održavanja. Minimalno vreme zastoja znači maksimalnu produktivnost za vašu operaciju.'
  }, {
    icon: AwardIcon,
    title: 'Garancija kvaliteta',
    description: 'Sveobuhvatna garancija i osiguranje kvaliteta. Stojimo iza svake jedinice sa stručnom tehničkom podrškom.'
  }];
  return <section className="py-20 bg-dark-surface border-b-2 border-dark-border" data-id="element-320">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-321">
        <div className="text-center mb-12" data-id="element-322">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4" data-id="element-323">
            {en ? <>
                Why choose <span className="text-brand-yellow" data-id="element-324">D-TECH</span>
              </> : ru ? <>
                Почему выбирают{' '}
                <span className="text-brand-yellow" data-id="element-325">D-TECH</span>
              </> : <>
                Zašto izabrati <span className="text-brand-yellow" data-id="element-326">D-TECH</span>
              </>}
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-327">
            {en ? 'Investing in the right equipment drives business success.' : ru ? 'Инвестиции в правильное оборудование способствуют успеху бизнеса.' : 'Investicija u pravu opremu pokreće poslovni uspeh.'}
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-328">
          {reasons.map(reason => {
          const Icon = reason.icon;
          return <Card key={reason.title} className="h-full" data-id="element-329">
                <div className="flex flex-col items-center text-center h-full" data-id="element-330">
                  <div className="w-16 h-16 bg-brand-yellow rounded-industrial flex items-center justify-center mb-4 flex-shrink-0" data-id="element-331">
                    <Icon className="w-8 h-8 text-dark-bg" data-id="element-332" />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-333">
                    {reason.title}
                  </h3>
                  <p className="text-gray-400 leading-relaxed flex-1" data-id="element-334">
                    {reason.description}
                  </p>
                </div>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}